import React from 'react';

import useModuleData from 'brand/app/contentful/hooks/useModuleData';
import ModuleFactory from 'brandComponents/ModuleFactory';

import {IModuleContentfulProps} from './IModuleContentful';

const ModuleContentful = (props: IModuleContentfulProps) => {
	const enrichedProps = useModuleData(props);

	return (
		<ModuleFactory
			id={enrichedProps?.sys?.id || ''}
			body={enrichedProps?.bodyCollection?.reactElements || []}
			links={enrichedProps?.linksCollection?.reactElements || []}
			{...enrichedProps}
		/>
	);
};

export default ModuleContentful;
